<div class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="selfModal.close()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ 'inspections.parts.import-sap-parts-prices' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
    <div class="ir-content--modal th-content">
      <div class="ir-parts-management">
        <p class="ir-parts-management-text">
          <b>{{ 'inspections.parts.prices-synchronization' | translate }}</b>
          <br />
          <span>{{ 'inspections.parts.prices-synchronization-text' | translate }}</span>
        </p>
        <div class="ir-parts-management-section">
          <table class="ir-modal-table">
            <tr>
              <td class="margin">
                <span *ngIf="!sapPricesAvailable">{{ 'inspections.parts.no-quotation-help' | translate : { country } }}</span>
              </td>
            </tr>
            <tr>
              <td width="50%" class="margin">
                <span *ngIf="sapPricesAvailable">
                  {{ 'inspections.parts.synchronize-prices' | translate }}&nbsp;
                  <ng-container *ngIf="lastSynchronization">
                    ({{ 'inspections.parts.last-synchro' | translate }} {{ lastSynchronization | date : 'short' }})
                  </ng-container>
                </span>
              </td>
              <td align="right" class="margin">
                <button
                  style="margin: 5px"
                  title="{{ 'inspections.parts.synchronize-help' | translate }}"
                  (click)="synchronize()"
                  class="ir-btn ir-btn--title th-btn-modal"
                >
                  <span>
                    {{ 'inspections.parts.synchronize' | translate }}
                  </span>
                </button>
              </td>
            </tr>
          </table>
          <table *ngIf="statuses && statuses.length" class="ir-modal-table">
            <tr>
              <td class="margin" width="50%">
                <span>{{ 'inspections.parts.number' | translate }}</span>
              </td>
              <td class="margin">
                <span>{{ 'inspections.parts.status' | translate }}</span>
              </td>
            </tr>
            <tr *ngFor="let status of statuses">
              <td class="margin" width="50%">
                <span>
                  <strong>{{ status.Number }}</strong>
                </span>
              </td>
              <td class="margin">
                <span>{{ 'plugins.parts.synchronization.' + status.Status | translate }}</span>
              </td>
            </tr>
            <tr>
              <td class="margin"></td>
              <td align="right" class="margin">
                <button (click)="dismiss()" class="ir-btn ir-btn--title">
                  <span>{{ 'inspections.parts.dismiss' | translate }}</span>
                </button>
              </td>
            </tr>
          </table>
        </div>
        <p class="ir-parts-management-text">
          <b>{{ 'inspections.parts.prices-export' | translate }}</b>
        </p>
        <div class="ir-parts-management-section">
          <p class="ir-parts-management-text">
            <span>{{ 'inspections.parts.prices-export-text' | translate }}</span>
          </p>
          <table class="ir-modal-table">
            <tr>
              <td width="50%" class="margin">
                <span>{{ 'inspections.parts.current-spare' | translate }}</span>
              </td>
              <td align="right" class="margin">
                <button
                  (click)="downloadMyBobstParts()"
                  style="margin: 5px"
                  title="{{ 'inspections.parts.extract-mybobst-help' | translate }}"
                  class="ir-btn ir-btn--title"
                  [class.th-btn-modal]="inspection.reportItemId"
                  [disabled]="!inspection.reportItemId"
                >
                  <i class="material-icons" style="margin-right: 8px">file_download</i>
                  <span>{{ 'inspections.parts.extract-mybobst' | translate }}</span>
                </button>
                <button
                  (click)="openExtractReportConfirm()"
                  class="ir-btn ir-btn--title"
                  style="margin: 5px"
                  title="{{ 'inspections.parts.extract-report-parts-help' | translate }}"
                  [class.th-btn-modal]="inspection.reportItemId"
                  [disabled]="!inspection.reportItemId"
                >
                  <i class="material-icons" style="margin-right: 8px">file_download</i>
                  <span>{{ 'inspections.parts.extract-reports-parts' | translate }}</span>
                </button>
              </td>
            </tr>
          </table>
        </div>
        <p class="ir-parts-management-text">
          <b>{{ 'inspections.parts.manual-importation' | translate }}</b>
          <br />
          <span>{{ 'inspections.parts.manual-importation-text' | translate }}</span>
        </p>
        <div class="ir-parts-management-section">
          <table class="ir-modal-table">
            <tr>
              <td width="50%" class="margin">
                <span>{{ 'inspections.parts.manual-import' | translate }}</span>
              </td>
              <td align="right" class="margin">
                <button
                  (click)="openQuotationSelector()"
                  style="margin: 5px"
                  title="{{ 'inspections.parts.import-mybobst-help' | translate }}"
                  class="ir-btn ir-btn--title th-btn-modal"
                >
                  <i class="material-icons" style="margin-right: 8px">file_upload</i>
                  <span>{{ 'inspections.parts.import-mybobst' | translate }}</span>
                </button>
                <button
                  (click)="openPricesSelector()"
                  style="margin: 5px"
                  title="{{ 'inspections.parts.import-excel-help' | translate }}"
                  class="ir-btn ir-btn--title th-btn-modal"
                >
                  <i class="material-icons" style="margin-right: 8px">file_upload</i>
                  <span>{{ 'inspections.parts.import-excel' | translate }}</span>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin12 ir-cell-sma12 ir-cell-mid12 ir-cell-lar12">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--center" (click)="selfModal.close()">
          <span>{{ 'common.close' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<input type="file" #quotationInput style="display: none" (change)="uploadQuotation($event)" multiple="true" />
<input type="file" #pricesInput style="display: none" (change)="uploadPartPrices($event)" multiple="true" />

<confirm
  #extractReportConfirm
  (confirmOutput)="downloadPartsReport()"
  [title]="'inspections.parts.download-confirm.title' | translate"
  [message]="'inspections.parts.download-confirm.message' | translate"
></confirm>
